import configureStore from 'widget/redux/configure-store';

export const createStore = configureStore;
